{
  "eyebrow": "Planınızı onaylayın",
  "title": "Gözden geçirin ve yapılandırın.",
  "sub": "Faturalama döngüsünü veya ürün hattınız içindeki planı yönetici panelinden istediğiniz zaman değiştirebilirsiniz. Time ile Project arasında geçiş ekibimizle birlikte ayarlanır.",
  "yourPlan": "Planınız",
  "changePlan": "Planı değiştir",
  "billing": "Faturalama döngüsü",
  "billingMonthLabel": "Aylık ödeme",
  "billingMonthDesc": "Esnek. İstediğiniz zaman iptal edin.",
  "billingYearLabel": "Yıllık ödeme",
  "billingYearDesc": "15% indirim. Yılda bir kez faturalandırılır.",
  "addons": "Eklentiler",
  "addon": {
    "ssec": "Sosyal güvenlik (check-in/out@work)",
    "ssecDesc": "Yalnızca Belçika — otomatik Dimona bildirimi.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Şirket araçları için canlı GPS. +4,80 €/araç/ay.",
    "vehicles": "Araçlar"
  },
  "users": {
    "title": "Kaç kullanıcıya ihtiyacınız var?",
    "help": "Done-it'i kullanan her kişi, yöneticiler ve çalışanlar dâhil, bir kullanıcı olarak sayılır.",
    "active": "kullanıcı"
  },
  "estimate": "Tahmini aylık maliyet",
  "estimateNote": "KDV hariç. Burada belirlediğiniz kullanıcı sayısı için ödeme yaparsınız ve bunu sonradan değiştirebilirsiniz.",
  "estimateUnavailable": "Fiyat kataloğu kullanılamıyor. En güncel fiyatları yüklemek için tekrar deneyin."
}
